// removed by extract-text-webpack-plugin
module.exports = {"HeaderAutoMessage":"HeaderAutoMessage__3_ATo","HeaderNoAutoMessage":"HeaderNoAutoMessage__3zf2_"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/AutoMessage/style.scss
// module id = C5vU
// module chunks = 0